<nav class="navbar navbar-expand-lg navbar-light topbar menu-fixo bg-white mb-4 px-0 pb-1">
  <button class="navbar-toggler ml-3" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" id="navbarButtonToggle"
    style="border: none;">
    <i class="bi bi-list" style="font-size: 1.4em; color: black"></i>
  </button>
  <a class="navbar-brand font-weight-bold d-flex align-items-center" [routerLink]="['/main/home']">
    <img [src]="logo ? logo?.logo :  '../../assets/images/logo-hd.png'" height="35"
      class="d-inline-block align-top mr-2" alt="">
  </a>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav ml-auto">

      <li class="nav-item no-arrow mx-auto my-3">
        <article class="d-inline-block mt-md-1 ml-menu-icons"> <!-- ICONES -->
          <a class="nav-link d-inline-block mr-2 mr-sm-3" (click)="closeNav()" [routerLink]="['/main/chat/chat-geral']"
            matTooltip="Chat Geral">
            <i class="fas fa-comments px-1" style="font-size: 1.1rem; color: #49a28f;"></i>
          </a>
          <a class="nav-link d-inline-block mr-2 mr-sm-3 navIcone" (click)="closeNav()"
            [routerLink]="['/main/tutorials']" matTooltip="Treinamentos e Tutoriais">
            <i class="far fa-file-video px-1" style="font-size: 1.1rem; color: #49a28f;"></i>
          </a>
          <a class="nav-link d-inline-block mr-2 mr-sm-3 navIcone" matTooltip="Chamados" role="button"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="position: relative;"
            [matMenuTriggerFor]="beforeMenuComunicacao" id="messagesDropdown">
            <i class="fa fa-headset fa-fw px-1" style="font-size: 1.1rem; color: #49a28f;"></i>
            <span class="badge badge-danger badge-counter"
              style="position: absolute; top: -12%; right: -12%; padding: 0.235em;"
              *ngIf="marca_chamado_enfermagem ||marca_chamado_ti ||marca_chat ||marca_chamado">
              1+
            </span>
          </a>
          <mat-menu #beforeMenuComunicacao="matMenu" xPosition="before">
            <mat-divider></mat-divider>
            <button mat-menu-item [routerLink]="['/main/chat/chamados-enfermagem']" (click)="closeNav()">
              <mat-icon>chat</mat-icon>
              <span>Chamados Enfermagem</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item [routerLink]="['/main/chat/chamados-ti']" (click)="closeNav()"
              *ngIf="user?.user?.pessoa?.profissional?.empresa_id == 2">
              <mat-icon>chat</mat-icon>
              <span>Chamados TI</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item [routerLink]="['/main/chat/chamados']" (click)="closeNav()">
              <mat-icon>chat</mat-icon>
              <span>Chamados</span>
            </button>
          </mat-menu>
          <a class="nav-link d-inline-block mr-2 mr-sm-3 navIcone" [matMenuTriggerFor]="beforeMenuNotificacao"
            matTooltip="Notificações" *ngIf="user.user.pessoa.profissional">
            <i class="fas fa-bell px-1" style="font-size: 1.1em; color: #49a28f"></i>
          </a>
          <mat-menu #beforeMenuNotificacao="matMenu" xPosition="after" [hasBackdrop]="false">
            <button mat-menu-item (click)="buscarNotificacoes()" (keydown)="$event.stopPropagation()">
              <mat-icon>refresh</mat-icon>
              <span>Refresh</span>
            </button>
            <mat-divider></mat-divider>
            <mat-tab-group (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
              <mat-tab label="Notificações">
                <mat-list class="custom">
                  <!--  -->
                  <mat-list-item *ngFor="let notificacao of notificacoes" style="cursor: pointer"
                    [style.background]="notificacao.visto ? '#fff' : '#eee'"
                    (click)="openDialogNotificacao(notificacao)">
                    <mat-icon mat-list-icon>notifications_active </mat-icon>
                    <div mat-line>{{ notificacao?.titulo }}</div>
                    <div mat-line>{{ notificacao?.conteudo }}</div>
                    <div md-line>
                      <mat-icon *ngIf="!notificacao.visto" mat-list-icon style="
                          color: hsl(214deg 89% 51%);
                          font-size: 14px;
                          padding: 0;
                        ">circle
                      </mat-icon>
                    </div>
                  </mat-list-item>
                </mat-list>
              </mat-tab>
              <mat-tab label="Alertas">
                <mat-list class="custom">
                  <!--  -->
                  <mat-list-item *ngFor="let aviso of avisos" style="cursor: pointer"
                    [style.background]="aviso.visto ? '#fff' : '#eee'" (click)="openDialogNotificacao(aviso)">
                    <mat-icon mat-list-icon>warning</mat-icon>
                    <div mat-line>{{ aviso?.titulo }}</div>
                    <div mat-line>{{ aviso?.conteudo }}</div>
                    <div md-line>
                      <mat-icon *ngIf="!aviso.visto" mat-list-icon style="
                          color: hsl(214deg 89% 51%);
                          font-size: 14px;
                          padding: 0;
                        ">circle</mat-icon>
                    </div>
                  </mat-list-item>
                </mat-list>
              </mat-tab>
            </mat-tab-group>
          </mat-menu>
          <a class="nav-link d-inline-block mr-md-0 navIcone navSearchIcon" matTooltip="Barra de Pesquisa"
            *ngIf="user.user.pessoa.profissional" (click)="searchSetState('minhaDiv2')"
            [ngClass]="searchActive ? ' navActiveSearchIcon ' : '' ">
            <i class="fas fa-search" style="font-size: 1.1rem; padding: 0px 3px; color: #49a28f;"></i>
          </a>
        </article>
        <div class="topbar-divider d-sm-inline d-none py-2 mx-4"></div>
        <article class="d-inline-block mt-md-1 ml-menu-icons"> <!-- ICONES -->
          <a class="nav-link d-inline-block" [matMenuTriggerFor]="beforeMenu" id="userDropdown" role="button"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" matTooltip="Perfil"
            style="padding: 0 !important">
            <img class="img-profile rounded-circle" style="width:42px; height: 42px" [src]="
          user?.user?.pessoa.perfil
            ? user?.user?.pessoa.perfil
            : '../../assets/images/user.png' " />
          </a>
        </article>
        <mat-menu #beforeMenu="matMenu" xPosition="before">
          <div class="profile-card">
            <div class="header p-4">
              <img [src]="
                  user?.user?.pessoa.perfil
                    ? user?.user?.pessoa.perfil
                    : '../../assets/images/user.png'
                " alt="Foto" style="display: block; margin: 0 auto" />
            </div>
            <h5 style="margin-top: 0">{{ user?.user?.pessoa?.nome }}</h5>
            <p class="small">{{ user?.user?.email }}</p>
          </div>
          <mat-divider></mat-divider>
          <button mat-menu-item [routerLink]="['/main/my-profile']">
            <mat-icon>account_circle</mat-icon>
            <span>Minha Conta</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            <span> Sair</span>
          </button>
          <mat-divider></mat-divider>
          <footer>
            <img src=" ../../assets/images/icon.ico" alt="ML" style="width: 32px" id="matMenuFooterImg" />
            <p style="text-align: center">&copy; Todos os direitos reservados.</p>
          </footer>
        </mat-menu>
      </li>


      <li id="minhaDiv2" style="display: none">
        <div class="mx-auto" style="width: 95%; display: block">
          <div [formGroup]="form">
            <mat-form-field appearance="fill" style="display: block; padding-top: 0; padding-bottom: 0;">
              <input matInput placeholder="O que você procura?" [matAutocomplete]="auto" formControlName="filter"
                style="padding-top: 0; padding-bottom: 0;" />
              <mat-autocomplete #auto="matAutocomplete">
                <mat-optgroup *ngFor="let cat of filteredOptions | async" label="{{ cat.module }}" class="optionsGroup">
                  <mat-option *ngFor="let tipo of cat.components" (click)="navigateTo(tipo.value)" class="options">
                    {{ tipo.label }}
                    <span style="
                        font-size: 11px;
                        display: flex;
                        margin-top: -30px;
                      ">{{ tipo.path }}</span>
                  </mat-option>
                </mat-optgroup>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </div>
      </li>

      <!-- Área Clínica -->
      <li class="nav-item nav-topics-links"
        *ngIf="verificaAcesso('Implantação') || verificaAcesso('Estatísticas') || verificaAcesso('Escala') || verificaAcesso('Parametrização') || verificaAcesso('Operação')">
        <div class="headAreaClinica">
          <p class="nav-link px-3 mb-0 py-2  ml-nav-titulo" type="button" data-toggle="collapse"
            data-target="#collapseAreaClinica" aria-expanded="true" aria-controls="collapseAreaClinica">
            Área Clínica</p>
        </div>

        <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headAreaClinica" id="collapseAreaClinica">

          <li>
            <div class="ml-nav-subLink" id="headClinica1" type="button" data-toggle="collapse"
              data-target="#collapseClinica1" aria-expanded="true" aria-controls="collapseClinica1">
              <p class="nav-link px-3 mb-0 py-2 ">Implantação</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headClinica1" id="collapseClinica1">
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/patients/list']">
                  Cadastro de Paciente</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/budgets/list']">
                  Cadastro de Orçamentos</a></li>
              <li *ngIf="verificaAcesso('PAD')"><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/operacao/pad']">
                  Cadastro do PAD</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/contracts/list']">
                  Ativação de Paciente</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/scales/escalas', 'new']">
                  Cadastro de Escalas</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/medication-transcripts/list']">
                  Transcrição de Medicamentos</a>
              </li>
            </ul>
          </li>

          <li>
            <div class="ml-nav-subLink" id="headClinica2" type="button" data-toggle="collapse"
              data-target="#collapseClinica2" aria-expanded="true" aria-controls="collapseClinica2">
              <p class="nav-link px-3 mb-0 py-2">Escala</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headClinica2" id="collapseClinica2">
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/bore-clearance/list']">Controle de Folgas/Furos</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/monitoring']">Monitoramento
                  de Escalas</a></li>
            </ul>
          </li>

          <li>
            <div class="ml-nav-subLink" id="headClinica4" type="button" data-toggle="collapse"
              data-target="#collapseClinica4" aria-expanded="true" aria-controls="collapseClinica4">
              <p class="nav-link px-3 mb-0 py-2">Operação</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headClinica4" id="collapseClinica4">
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/monitoring/clinical-evolution']">
                  Acompanhento de Paciente</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/home']">
                  Assistência Farmacêutica</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/documents/list']">
                  Documentos Manuais</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/operacao/ocorrencias-resolvidas']">
                  Ocorrências Resolvidas</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/general-reports/list']">
                  Relatório</a></li>
            </ul>
          </li>

          <li>
            <div class="ml-nav-subLink" id="headClinica3" type="button" data-toggle="collapse"
              data-target="#collapseClinica3" aria-expanded="true" aria-controls="collapseClinica3">
              <p class="nav-link px-3 mb-0 py-2">Estatisticas
              </p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headClinica3" id="collapseClinica3">
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/customer-area/list']">
                  Área do Convênio</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/clinical-area/dashboard']">
                  Dashboard de Atendimento</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/cooperative/dashboard']">
                  Dashboard de Cooperativas</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/bidding/dashboard']">
                  Dashboard de Orçamento</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/overview']">
                  Dashboard de Profissionais</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/operacao/management-control']">
                  Timeline do Paciente</a></li>
            </ul>
          </li>

          <li>
            <div class="ml-nav-subLink" id="headClinica5" type="button" data-toggle="collapse"
              data-target="#collapseClinica5" aria-expanded="true" aria-controls="collapseClinica5">
              <p class="nav-link px-3 mb-0 py-2">Parametrização</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headClinica5" id="collapseClinica5">
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/operacao/diagnostics-cid-10']">
                  Consulta de Diagnósticos Médicos (CID-10)</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/cares/list']">
                  Cadastro de Procedimentos</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/care-groups/list']">
                  Cadastro de Grupo de Procedimentos de Enfermagem</a></li>
            </ul>
          </li>
        </ul>

      </li>
      <li class="nav-item nav-topics-links" *ngIf="!verificaAcesso('Área Clínica') && user.user.pessoa.prestador">
        <div class="headAreaClinica2">
          <p class="nav-link px-3 mb-0 py-2  ml-nav-titulo" type="button" data-toggle="collapse"
            data-target="#collapseAreaClinica2" aria-expanded="true" aria-controls="collapseAreaClinica2">
            Área Clínica</p>
        </div>

        <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headAreaClinica2" id="collapseAreaClinica2">
          <li>
            <div class="ml-nav-subLink" id="headClinica25" type="button" data-toggle="collapse"
              data-target="#collapseClinica25" aria-expanded="true" aria-controls="collapseClinica25">
              <p class="nav-link px-3 mb-0 py-2">Evolução Clínica</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headClinica25" id="collapseClinica25">
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/supplier-reports/my-reports/list']">
                  Evolução Mensal</a></li>
            </ul>
          </li>
        </ul>

      </li>

      <!-- PAD -->
      <!-- <li class="nav-item nav-topics-links" *ngIf="verificaAcesso('PAD')">
        <div class="headPAD">
          <p class="nav-link px-3 mb-0 py-2  ml-nav-titulo" type="button" data-toggle="collapse"
            data-target="#collapsePAD" aria-expanded="true" aria-controls="collapsePAD">
            PAD</p>
        </div>

        <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headPAD" id="collapsePAD">
          <li>
            <div class="ml-nav-subLink" id="headPAD1" type="button" data-toggle="collapse" data-target="#collapsePAD1"
              aria-expanded="true" aria-controls="collapsePAD1">
              <p class="nav-link px-3 mb-0 py-2">
                Cadastros</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headPAD1" id="collapsePAD1">
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/pils/listaDiagnosticos']">Diagnósticos
                  Primários</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/pils/listaDiagnosticosSecundarios']">Diagnósticos
                  Secundários</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/pils/listaPrescricoesA']">Prescrições A</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/pils/listaGruposPrescricaoA']">Grupo de
                  Prescrições A</a>
              </li>
            </ul>
          </li>
          <li>
            <div class="ml-nav-subLink" id="headPAD2" type="button" data-toggle="collapse" data-target="#collapsePAD2"
              aria-expanded="true" aria-controls="collapsePAD2">
              <p class="nav-link px-3 mb-0 py-2">
                Planilhas</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headPAD2" id="collapsePAD2">
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/pils/listaNeads']">Nead</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/pils/listaAbemids']">Abemid</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/pils/listaAnexosA']">SAE</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/pils/listaAnexosB']">Sócio
                  Ambiental</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/pils/listaPil']">PIL</a></li>
            </ul>
          </li>
          <li>
            <div class="ml-nav-subLink" id="headPAD3" type="button" data-toggle="collapse" data-target="#collapsePAD3"
              aria-expanded="true" aria-controls="collapsePAD3">
              <p class="nav-link px-3 mb-0 py-2">
                Protocolos</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headPAD3" id="collapsePAD3">
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/protocolo/protocolo-avaliacao-estoma']">Avalação
                  de
                  Estomas</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/protocolo/protocolo-avaliacao-feridas']">Avaliação
                  de
                  Feridas</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/protocolo/protocolo-medicacao']">Medicação</a>
              </li>
            </ul>
          </li>
        </ul>
      </li> -->

      <!-- Relatórios -->
      <li class="nav-item nav-topics-links" *ngIf="user.user.pessoa.prestador">
        <div class="headRelatorios">
          <p class="nav-link px-3 mb-0 py-2  ml-nav-titulo" type="button" data-toggle="collapse"
            data-target="#collapseRelatorios" aria-expanded="true" aria-controls="collapseRelatorios">
            Relatórios</p>
        </div>

        <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headRelatorios" id="collapseRelatorios">
          <li>
            <div class="ml-nav-subLink" id="headRelatorios1" type="button" data-toggle="collapse"
              data-target="#collapseRelatorios1" aria-expanded="true" aria-controls="collapseRelatorios1">
              <p class="nav-link px-3 mb-0 py-2">Relatórios
              </p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headRelatorios1"
              id="collapseRelatorios1">
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/supplier-reports/my-reports/list']">Meus
                  Relatórios</a>
              </li>
            </ul>
          </li>
        </ul>
      </li>

      <!-- Área Administrativa -->
      <li class="nav-item nav-topics-links"
        *ngIf="verificaAcesso('Financeiro') || verificaAcesso('Medição') || verificaAcesso('Cadastro de Contratos') || verificaAcesso('TI') || verificaAcesso('RH') || verificaAcesso('Agendamento') || verificaAcesso('Diretoria') || verificaAcesso('Faturamento')">
        <div class="headAreaADM">
          <p class="nav-link px-3 mb-0 py-2  ml-nav-titulo" type="button" data-toggle="collapse"
            data-target="#collapseAreaADM" aria-expanded="true" aria-controls="collapseAreaADM">
            Área Administrativa</p>
        </div>

        <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headAreaADM" id="collapseAreaADM">
          <li *ngIf="verificaAcesso('Faturamento') || verificaAcesso('Financeiro')">
            <div class="ml-nav-subLink" id="headADM1" type="button" data-toggle="collapse" data-target="#collapseADM1"
              aria-expanded="true" aria-controls="collapseADM1" *ngIf="verificaAcesso('Faturamento')">
              <p class="nav-link px-3 mb-0 py-2">
                Faturamento</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headADM1" id="collapseADM1">
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/billing/dashboard']">
                  Dashboard</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/contracts/list']">
                  Ativação de Paciente</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/budgets/list']">
                  Cadastro de Orçamentos</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/tiss/list']">
                  TISS</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/metering/list']">
                  Medições (Capa de Lote)</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/claim-management/list']">
                  Gestão de Glosas</a></li>
            </ul>
          </li>

          <li *ngIf="verificaAcesso('Financeiro')">
            <div class="ml-nav-subLink" id="headADM2" type="button" data-toggle="collapse" data-target="#collapseADM2"
              aria-expanded="true" aria-controls="collapseADM2" *ngIf="verificaAcesso('Financeiro')">
              <p class="nav-link px-3 mb-0 py-2">Financeiro</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headADM2" id="collapseADM2">
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/purchasing-quotations/list']">
                  Cotações de Compras</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/cash-flows/list']">
                  Fluxo de Caixa</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/financial/reports/list']">
                  Relatório Financeiro</a></li>

              <li><a class="dropdown-item li-subTitulo py-2">Cadastros</a></li>

              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/categories-natures/list']">
                  Cadastro de Categoria de Natureza</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/bank-accounts/list']">
                  Cadastro de Conta Bancária</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/suppliers/list']">
                  Cadastro de Fornecedores</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/natures/list']">
                  Cadastro de Naturezas</a>
              </li>

              <li><a class="dropdown-item li-subTitulo py-2">Pagamentos</a></li>

              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/accounts/list-accounts-payable']">
                  Contas a Pagar</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/accounts/list-accounts-receivables']">
                  Contas a Receber</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/cnab-payments/list']">
                  Cadastro de Pagamentos (CNAB)</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/pix-payments/list']">
                  Cadastro de Pagamentos (Pix)</a>
              </li>
            </ul>
          </li>

          <li *ngIf="verificaAcesso('Cadastro de Contratos')">
            <div class="ml-nav-subLink" id="headADM3" type="button" data-toggle="collapse" data-target="#collapseADM3"
              aria-expanded="true" aria-controls="collapseADM3" *ngIf="verificaAcesso('Cadastro de Contratos')">
              <p class="nav-link px-3 mb-0 py-2">Cadastro de Contratos</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headADM3" id="collapseADM3">
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/clients/list']">
                  Cadastro de Contratante</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/costs/list']">
                  Cadastro de Custos</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/services/list']">
                  Cadastro de Serviços</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/packages/list']">
                  Cadastro de Pacotes</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/responsibles/list']">
                  Lista de Responsabilidades</a></li>
              <li><a class="dropdown-item li-subTitulo py-2">-</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/customer-area/list']">
                  Área Convênio</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/taxes/list']">
                  Cadastro de Impostos</a></li>
            </ul>
          </li>

          <li *ngIf="verificaAcesso('TI')">
            <div class="ml-nav-subLink" id="headADM5" type="button" data-toggle="collapse" data-target="#collapseADM5"
              aria-expanded="true" aria-controls="collapseADM5">
              <p class="nav-link px-3 mb-0 py-2">
                TI</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headADM5" id="collapseADM5">
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/ti/acessos/cliente']">Acesso
                  de Convênio</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/ti/acessos/profissional']">Acesso de Colaboradores</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/ti/acessos/responsavel']">Acesso de Responsáveis</a>
              </li>
            </ul>
          </li>

          <li *ngIf="verificaAcesso('Diretoria')">
            <div class="ml-nav-subLink" id="headADM7" type="button" data-toggle="collapse" data-target="#collapseADM7"
              aria-expanded="true" aria-controls="collapseADM7"
              *ngIf="user?.user?.pessoa?.profissional?.empresa_id == 2 || verificaAcesso('Diretoria')">
              <p class="nav-link px-3 mb-0 py-2">
                Diretoria</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headADM7" id="collapseADM7">
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/directors/company']">
                  Configurações da Empresa</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/directors/approve-payments/list']">
                  Lista de Pagamentos</a></li>
            </ul>
          </li>

          <li *ngIf="verificaAcesso('RH')">
            <div class="ml-nav-subLink" id="headADM9" type="button" data-toggle="collapse" data-target="#collapseADM9"
              aria-expanded="true" aria-controls="collapseADM9">
              <p class="nav-link px-3 mb-0 py-2">RH / DP</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headADM9" id="collapseADM9">
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/auxiliary-records']">Cadastro
                  de Benefícios, Cargos e Etc</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/external-electronic-points/list']">
                  Ponto Eletrônico</a></li>

              <li><a class="dropdown-item li-subTitulo py-2">Profissionais</a></li>

              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/service-providers/list']">
                  Cadastro de Profissional Externo</a></li>

              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/professionals/list']">
                  Cadastro de Profissional Interno</a></li>

              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/users/list']">
                  Recrutamento de Profissionais</a></li>

              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/reports-providers/list']">
                  Relatórios de Profissionais Externos</a></li>

              <li><a class="dropdown-item li-subTitulo py-2">Profissionais</a></li>

              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/outer-sheets/list']">
                  Folha Externa</a></li>

              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/outer-sheets/clt/list']">
                  Folha Externa (CLT)</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/payrolls/internal-payments/list']">
                  Folha Interna</a></li>
            </ul>
          </li>

          <li *ngIf="user?.user?.pessoa?.profissional?.empresa_id == 2">
            <div class="ml-nav-subLink" id="headADM6" type="button" data-toggle="collapse" data-target="#collapseADM6"
              aria-expanded="true" aria-controls="collapseADM6">
              <p class="nav-link px-3 mb-0 py-2">
                Administrador</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headADM6" id="collapseADM6"
              *ngIf="user?.user?.pessoa?.profissional?.empresa_id == 2">
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/companies/list']">Empresas
                  (Clientes)</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/users-access/list']">Usuários</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/notifications/list']">Notificações
                  (Atualizações)</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/ti/dashboard']">Dashboard de
                  Chamados</a></li>
            </ul>
          </li>


          <li *ngIf="verificaAcesso('Agendamento')">
            <div class="ml-nav-subLink" id="headADM4" type="button" data-toggle="collapse" data-target="#collapseADM4"
              aria-expanded="true" aria-controls="collapseADM4">
              <p class="nav-link px-3 mb-0 py-2">
                Agendamentos</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headADM4" id="collapseADM4">
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/calendar-room-meeting/list']">Cadastro de Agendamento</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/meeting-rooms/list']">Salas
                  de
                  Reunião</a></li>
            </ul>
          </li>
        </ul>
      </li>

      <!-- Suprimentos -->
      <li class="nav-item nav-topics-links"
        *ngIf="verificaAcesso('Compras') || verificaAcesso('Estoque') || verificaAcesso('Requisição Material')">
        <div class="headSuprimentos">
          <p class="nav-link px-3 mb-0 py-2  ml-nav-titulo" type="button" data-toggle="collapse"
            data-target="#collapseSuprimentos" aria-expanded="true" aria-controls="collapseSuprimentos">
            Suprimentos</p>
        </div>

        <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headSuprimentos" id="collapseSuprimentos">
          <li *ngIf="verificaAcesso('Compras')">
            <div class="ml-nav-subLink" id="headSuprimentos1" type="button" data-toggle="collapse"
              data-target="#collapseSuprimentos1" aria-expanded="true" aria-controls="collapseSuprimentos1">
              <p class="nav-link px-3 mb-0 py-2">
                Compras</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headSuprimentos1"
              id="collapseSuprimentos1">
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/suppliers/list']">Fornecedores</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/products/list']">MAT/MED -
                  Equipamentos</a></li>
              <li><a class="dropdown-item li-subTitulo py-2">Tabelas</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/tables/brasindice']">Brasindice</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/tables/simpro']">Simpro</a>
              </li>
            </ul>
            <div class="ml-nav-subLink" id="headSuprimentos3" type="button" data-toggle="collapse"
              data-target="#collapseSuprimentos3" aria-expanded="true" aria-controls="collapseSuprimentos3"
              *ngIf="verificaAcesso('Estoque')">
              <p class="nav-link px-3 mb-0 py-2">
                Estoque</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headSuprimentos3"
              id="collapseSuprimentos3">

              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/inventory/products/input/list']">Entrada Nota
                  Fiscal</a>
              </li>

              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/entry-single/list']">Entrada
                  Avulsa</a></li>

              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/inventory/stock/list']">Relatório Estoque</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/mat-med/stock-control']">Controle de Estoque</a></li>

              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/output-single/list']">Saída
                  Avulsa</a></li>

              <li><a class="dropdown-item py-2" (click)="closeNav()" [routerLink]="['/main/purchase-orders/list']">
                  Solicitação de Compra</a></li>
            </ul>
            <div class="ml-nav-subLink" id="headSuprimentos4" type="button" data-toggle="collapse"
              data-target="#collapseSuprimentos4" aria-expanded="true" aria-controls="collapseSuprimentos4"
              *ngIf="verificaAcesso('Requisição Material')">
              <p class="nav-link px-3 mb-0 py-2">
                Requisição Material</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headSuprimentos1"
              id="collapseSuprimentos4">
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/material-requisitions/list']">Requisição de
                  Material</a>
              </li>
            </ul>
          </li>
        </ul>
      </li>

      <!-- NEW Responsável  -->
      <li class="nav-item nav-topics-links" *ngIf="verificaAcesso('Responsável') && user.user.pessoa.responsavel">
        <div class="headResponsavel">
          <p class="nav-link px-3 mb-0 py-2  ml-nav-titulo" type="button" data-toggle="collapse"
            data-target="#collapseResponsavel" aria-expanded="true" aria-controls="collapseResponsavel">
            Responsável</p>
        </div>

        <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headResponsavel" id="collapseResponsavel">
          <li>
            <div class="ml-nav-subLink" id="headResponsavel1" type="button" data-toggle="collapse"
              data-target="#collapseResponsavel1" aria-expanded="true" aria-controls="collapseResponsavel1">
              <p class="nav-link px-3 mb-0 py-2">
                Responsável</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headResponsavel1"
              id="collapseResponsavel1">
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/responsible/signatures/list']">Assinaturas</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/responsible/patients/list']">Meus Pacientes</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/responsible/monitoring']">Monitoramento</a></li>
            </ul>
          </li>
        </ul>
      </li>

      <!-- NEW CONVÊNIO -->
      <li class="nav-item nav-topics-links" *ngIf="verificaAcesso('Convênio') && user.user.pessoa.cliente">
        <div class="headConvenio">
          <p class="nav-link px-3 mb-0 py-2  ml-nav-titulo" type="button" data-toggle="collapse"
            data-target="#collapseConvenio" aria-expanded="true" aria-controls="collapseConvenio">
            Convênio (Tomador)</p>
        </div>

        <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headConvenio" id="collapseConvenio">
          <li>
            <div class="ml-nav-subLink" id="headConvenio1" type="button" data-toggle="collapse"
              data-target="#collapseConvenio1" aria-expanded="true" aria-controls="collapseConvenio1">
              <p class="nav-link px-3 mb-0 py-2">
                Visão Geral</p>
              <i class="bi bi-caret-down-fill menuCaretIcon"></i>
            </div>
            <ul class="collapse py-0 my-0 px-0 ml-border-menu" aria-labelledby="headConvenio1" id="collapseConvenio1">
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/insurence/monitoring/list']">Dashboard</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/insurence/manual-documents/list']">Documentos
                  Manuais</a>
              </li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/insurence/metering/list']">Medição (Capa de
                  Lote)</a></li>
              <li><a class="dropdown-item py-2" (click)="closeNav()"
                  [routerLink]="['/main/insurence/reports/list/new']">Meus Pacientes</a>
              </li>
            </ul>
          </li>
        </ul>
      </li>

    </ul>
  </div>
</nav>
